import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";
import styles from "./columnManagerModal.module.css";
import CloseIcon from "../../../assets/icons/circle-xmark.svg";

const ColumnManagerModal = ({ 
  onClose, 
  onApply, 
  availableColumns, 
  selectedColumns,
  defaultColumns 
}) => {
  const [localSelectedColumns, setLocalSelectedColumns] = useState(selectedColumns);

  useEffect(() => {
    setLocalSelectedColumns(selectedColumns);
  }, [selectedColumns]);

  const handleColumnToggle = (columnKey) => {
    setLocalSelectedColumns(prev => {
      const isSelected = prev.includes(columnKey);
      return isSelected
        ? prev.filter(k => k !== columnKey)
        : [...prev, columnKey];
    });
  };

  const handleSelectAll = () => {
    setLocalSelectedColumns(availableColumns.map(col => col.key));
  };

  const handleClearAll = () => {
    // Mantém apenas a primeira coluna (geralmente ID)
    setLocalSelectedColumns([availableColumns[0]?.key].filter(Boolean));
  };

  const handleRestore = () => {
    setLocalSelectedColumns(defaultColumns);
  };

  const handleApply = () => {
    onApply(localSelectedColumns);
    onClose();
  };

  const modalContent = (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {/* Cabeçalho */}
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Configurações de Exibição</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <img src={CloseIcon} alt="Fechar" />
          </button>
        </div>

        {/* Corpo do Modal */}
        <div className={styles.modalBody}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionTitleArea}>
              <h3 className={styles.sectionTitle}>Gerenciar Colunas</h3>
              <p className={styles.sectionDescription}>
                Selecione as colunas que deseja visualizar
              </p>
            </div>
            <div className={styles.actionButtons}>
              <button 
                className={styles.actionButton}
                onClick={handleSelectAll}
                title="Selecionar todas as colunas"
              >
                ✓ Selecionar Todos
              </button>
              <button 
                className={styles.actionButton}
                onClick={handleClearAll}
                title="Limpar seleção"
              >
                ✗ Limpar Seleção
              </button>
              <button 
                className={styles.actionButtonPrimary}
                onClick={handleRestore}
                title="Restaurar colunas padrão"
              >
                ↺ Restaurar
              </button>
            </div>
          </div>

          <div className={styles.columnsGrid}>
            {availableColumns.map(col => (
              <label key={col.key} className={styles.columnCheckbox}>
                <input
                  type="checkbox"
                  checked={localSelectedColumns.includes(col.key)}
                  onChange={() => handleColumnToggle(col.key)}
                  className={styles.checkbox}
                />
                <span className={styles.checkboxText}>{col.label}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Rodapé */}
        <div className={styles.modalFooter}>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancelar
          </button>
          <button 
            className={styles.applyButton} 
            onClick={handleApply}
          >
            Aplicar Seleção
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDom.createPortal(modalContent, document.body);
};

export default ColumnManagerModal;

